import {Day, Period} from "lib/types";


const dayMap: Record<Day, string> = {
    monday: "M",
    tuesday: "Tu",
    wednesday: "W",
    thursday: "Th",
    friday: "F",
    saturday: "Sa",
    sunday: "Su",
};

const dayOrder = ["M", "Tu", "W", "Th", "F", "Sa", "Su"];

function capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

function fetchAvailability(rawJson: string):
    { daysSet: Set<string>, periodsSet: Set<string> } {
    const data: string[] = JSON.parse(rawJson);

    const daysSet: Set<string> = new Set();
    const periodsSet: Set<string> = new Set();

    data.forEach((item: string) => {
        const [dayRaw, periodRaw] = item.split(" ");
        const day = dayRaw.toLowerCase() as Day;
        const period = periodRaw.toLowerCase() as Period;

        if (dayMap[day]) daysSet.add(dayMap[day]);
        periodsSet.add(capitalize(period));
    });

    return {daysSet, periodsSet}
}

export function summarizeDaysAvailability(rawJson: string): string {
    const {daysSet, periodsSet} = fetchAvailability(rawJson);

    const sortedDays = Array.from(daysSet).sort(
        (a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b)
    );

    return sortedDays.join(" | ");
}

export function summarizePeriodsAvailability(rawJson: string): string {
    const {daysSet, periodsSet} = fetchAvailability(rawJson);

    const sortedPeriods = Array.from(periodsSet).sort();
    return sortedPeriods.join(" / ");
}


export function summarizeAvailability(rawJson: string): string {
    const days = summarizeDaysAvailability(rawJson);
    const periods = summarizePeriodsAvailability(rawJson);

    return `${days} | ${periods}`;
}